/**
 * 热词打点
 * 使用示例
 * ```javascript
 * // 初始化
 * Pingback.initState({uid, sign, c})
 * // 真实展现打点
 * Pingback.show(params)
 * ```
 */
const showPingback = 'https://realshow.look.360.cn/srv/c';
const clickPingback = 'https://statis.look.360.cn/srv/c';
const click2Pingback = 'https://statis.look.360.cn/srv/c2';

// 写一个 isEmpty 方法，需要判断空对象、空数组
const isEmpty = (str) => {
  if (typeof str === 'string') {
    return str.trim() === ''
  }
  if (Array.isArray(str)) {
    return str.length === 0
  }
  if (typeof str === 'object') {
    return Object.keys(str).length === 0
  }
  // 需要判断 null、undefined 等类型
  return str == null
}

// web     360_f67c51e2     namimarquee_web  
// h5     360_d3bc95ac     namimarquee_h5  
// 移动     360_7d272d21     namimarquee_mobile  
// pc     360_f639c415     namimarquee_pc
// $SCENE: 315

/**
 * 上述参数可能不是最新记得对一下 https://geelib.qihoo.net/geelib/knowledgeShare?shorturl=5b92e27493329abdc5b2ea1bc6
 */
let stateStore = {
  hsid: `${Date.now()}`/** 会话ID，如果需要当前会话级别消重，可使用此参数，生成规则：会话期间唯一 */,
  sign: '',
  c: '',
  scene: '315',
}
let isInit = false
/** 使用本文件提供的打点方法请记得先执行这个方法初始化 */
const initState = ({ uid, sign, c }) => {
  if (!uid || !sign || !c) {
    console.warn('使用 pingpack 打点请传入正确的参数')
    return
  }
  isInit = true
  Object.assign(stateStore, {
    uid,
    sign,
    c,
  })
}

const ua = (window.navigator ? navigator.userAgent.toLowerCase() : '')
function isIphone() {
  return /iphone|ipad/i.test(ua) && !/android/i.test(ua)
}
function isHarmony() {
  return /Mobile/i.test(ua) && /Harmony/i.test(ua)
}
function isPhone() {
  return /android|iphone|360browser|ipad|mobile|phone/i.test(ua)
}
// 返回 0 安卓 1 iOS 2 pc 3 鸿蒙
function getPlatform() {
  if (isIphone()) return 1
  if (isHarmony()) return 3
  if (isPhone() && !isIphone() && !isHarmony()) return 0
  return 2 // pc
}

// 手动拼接 URL 和查询参数
function buildUrl(baseUrl = '', query = {}) {
  const queryString = Object.keys(query)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`)
    .join('&');
  return `${baseUrl}?${queryString}`;
}
const pingback = function (url = '', query = {}) {
  if (!isInit) {
    console.warn('因为没有传入正确参数，所以不予打点')
    return
  }
  if (!url || isEmpty(query)) return
  const target = buildUrl(url, query);
  let img = new Image();
  img.src = target;

  img.onload = img.onerror = function () {
    img = null;
  };
};

/** 用于记录已打点 */
const hasShowPings = {}
/**
 * 资讯卡片曝光
 * @param {*} params 
 */
const show = function (params = {}) {
  if (isEmpty(params)) return
  // 不重复打点
  if (hasShowPings[params.id]) return
  hasShowPings[params.id] = true
  // return console.info('正在打点', params)
  const { gnid, source, s, sid, index, rawurl, c, sign } = params
  const passings = {
    sign: sign || stateStore.sign,
    scene: stateStore.scene,
    channel: c || stateStore.c,
    where: 'list',
    uid: stateStore.uid,
    act: 'real_show',
    device: getPlatform(),
    func: 'pc_news_realshow',
    url_pack: JSON.stringify([[
      gnid/**接口返回*/,
      '' /*a占位*/,
      '' /*c新闻类型接口返回*/,
      source/**接口返回*/,
      s/**接口返回*/,
      '' /*style占位*/,
      2000 /*showtime*/,
      sid ?? ''/**接口返回*/,
      (index ?? '')/**内容为止，从0开始，从上到下/从左到右累计*/,
      rawurl/**接口返回*/,
    ]]),
    hsid: stateStore.hsid,
    qid: stateStore.uid,
  }
  pingback(showPingback, passings);
};

/**
 * 内容点击
 * @param {*} params 
 */
const click = function (params = {}) {
  if (isEmpty(params)) return
  pingback(clickPingback, {
    sign: params.sign || stateStore.sign,
    scene: stateStore.scene,
    channel: params.c || stateStore.c,
    where: 'list',
    uid: stateStore.uid,
    device: getPlatform(),
    act: 'click',
    rawurl: params.rawurl,
    gnid: params.gnid,
    source: params.source,
    s: params.s,
    hsid: stateStore.hsid,
    position: params.index, // 位置，从0开始，从上到下/从左到右累计
    qid: stateStore.uid,
  });
};

/**
 * query词功能点击
 * @param {*} params 
 */
const fnclick = function (params = {}, ext = null) {
  // if (isEmpty(params)) return
  const { sign } = params
  pingback(click2Pingback, {
    act: 'click',
    sign: stateStore.sign || sign,
    func: 'ainami_query',
    device: getPlatform(),
    uid: stateStore.uid,
    ext, // 搜索词
    qid: stateStore.uid,
  });
};

export const Pingback = {
  show,
  click,
  fnclick,
  initState,
  stateStore,
};
